module.exports = __webpack_public_path__ + "img/WhatsApp.fbfe4bed.png";